import { Component } from '@angular/core';
import { UserService } from './service/basic/user.service';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SafeArea } from './plugin/safearea.plugin';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  workerMenuList = [
    { icon: "man-outline", user_level: 'SAFETY', label: "근로자 관리", routerLink: "/partner/worker-manage-list" },
    { icon: "body-outline", user_level: 'SAFETY', label: "일용직 관리", routerLink: "/partner/worker-manage-list-day-labor" },
    { icon: "calendar-number-outline", user_level: 'SAFETY', label: "TBM 현황", routerLink: "/partner/today-tbm-list", queryParams: {type:'ALL'} },
    { icon: "calendar-outline", user_level: 'SAFETY', label: "일용직 TBM 현황", routerLink: "/partner/today-tbm-list-day-labor", queryParams: {type:'ALL'} },
    { icon: "notifications-circle-outline", user_level: 'SAFETY', label: "TBM 공지사항", routerLink: "/partner/notice-tbm" },
    { icon: "clipboard-outline", user_level: 'SAFETY', label: "TBM 교육자료 현황", routerLink: "/partner/tbm-status" },
    { icon: "newspaper-outline", label: "작업이력", routerLink: "/worker/my-work-list" },
    { icon: "notifications-outline", label: "공지사항", routerLink: "/notice-app" },
    { icon: "warning-outline", user_level: 'BASIC', label: "긴급알림", routerLink: "/worker/notice-emergency" },
    { icon: "warning-outline", user_level: 'SAFETY', label: "긴급알림", routerLink: "/partner/notice-emergency" }
  ]

  endWorkerMenuList = [
    { icon: "newspaper-outline", label: "작업이력", routerLink: "/worker/my-work-list" },
    { icon: "notifications-outline", label: "공지사항", routerLink: "/notice-app" },
    { icon: "warning-outline", user_level: 'BASIC', label: "긴급알림", routerLink: "/worker/notice-emergency" },
    { icon: "warning-outline", user_level: 'SAFETY', label: "긴급알림", routerLink: "/partner/notice-emergency" }
  ]

  partnerMenuList = [
    { icon: "man-outline", label: "근로자 관리", routerLink: "/partner/worker-manage-list" },
    { icon: "body-outline", label: "일용직 관리", routerLink: "/partner/worker-manage-list-day-labor" },
    { icon: "calendar-number-outline", label: "TBM 현황", routerLink: "/partner/today-tbm-list", queryParams: {type:'ALL'} },
    { icon: "calendar-outline", label: "일용직 TBM 현황", routerLink: "/partner/today-tbm-list-day-labor", queryParams: {type:'ALL'} },
    { icon: "notifications-circle-outline", label: "TBM 공지사항", routerLink: "/partner/notice-tbm" },
    { icon: "clipboard-outline", label: "TBM 교육자료 현황", routerLink: "/partner/tbm-status" },
    { icon: "warning-outline", label: "긴급알림", routerLink: "/partner/notice-emergency" },
    { icon: "notifications-outline", label: "공지사항", routerLink: "/notice-app" },
  ]

  dayLaborCount:number = 0;

  constructor(
    public user: UserService
  ) {
    /* this.plt.backButton.subscribeWithPriority(-1, (processNextHandler) => {
      if (!this.routerOutlet.canGoBack()) {
        App.exitApp();
      }
    }); */

    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    }, false);

    history.pushState(null, null, document.URL);

    // ANDROID 전용 SafeArea 적용 및 리스너 등록
    this.queueApplyAndroidSafeArea();
    const onResize = () => this.queueApplyAndroidSafeArea();
    window.addEventListener('resize', onResize);
    (window as any).visualViewport?.addEventListener?.('resize', onResize);

    // ANDROID 상태바 스타일 고정 (검은 배경 + 흰 아이콘)
    this.applyAndroidStatusBarStyle();
  }

  private safeAreaRetryTimer: any;
  private safeAreaResizeTimer: any;

  /**
   * resize 이벤트 등으로 연속 호출되는 것을 디바운스하여
   * 불필요한 네이티브 호출을 줄인다.
   */
  private queueApplyAndroidSafeArea() {
    if (this.safeAreaResizeTimer) clearTimeout(this.safeAreaResizeTimer);
    this.safeAreaResizeTimer = setTimeout(() => this.applyAndroidSafeArea(), 80);
  }

  /**
   * SafeArea 값을 가져와 Ionic CSS 변수에 반영한다.
   * 초기 프레임에서 0이 들어오는 기기를 고려해 짧게 재시도한다.
   */
  private applyAndroidSafeArea(retry = 0) {
    if (Capacitor.getPlatform() !== 'android') return;

    SafeArea.getInsets()
      .then(({ top, bottom, left, right }) => {
        // 일부 기기에서는 첫 호출이 0으로 올 수 있어 짧게 재시도
        if (top === 0 && bottom === 0 && left === 0 && right === 0 && retry < 5) {
          if (this.safeAreaRetryTimer) clearTimeout(this.safeAreaRetryTimer);
          this.safeAreaRetryTimer = setTimeout(() => this.applyAndroidSafeArea(retry + 1), 120);
          return;
        }
        const root = document.documentElement;
        // root.style.setProperty('--safe-area-top', `${top}px`);
        // root.style.setProperty('--safe-area-bottom', `${bottom}px`);
        // root.style.setProperty('--safe-area-left', `${left}px`);
        // root.style.setProperty('--safe-area-right', `${right}px`);

        // Ionic 기본 변수도 동기 주입 (ANDROID 한정)
        root.style.setProperty('--ion-safe-area-top', `${top}px`);
        root.style.setProperty('--ion-safe-area-bottom', `${bottom}px`);
        root.style.setProperty('--ion-safe-area-left', `${left}px`);
        root.style.setProperty('--ion-safe-area-right', `${right}px`);
      })
      .catch(() => {
        const root = document.documentElement;
        // root.style.setProperty('--safe-area-top', `0px`);
        // root.style.setProperty('--safe-area-bottom', `0px`);
        // root.style.setProperty('--safe-area-left', `0px`);
        // root.style.setProperty('--safe-area-right', `0px`);

        // 실패 시에도 Ionic 기본 변수 초기화 (ANDROID 한정)
        root.style.setProperty('--ion-safe-area-top', `0px`);
        root.style.setProperty('--ion-safe-area-bottom', `0px`);
        root.style.setProperty('--ion-safe-area-left', `0px`);
        root.style.setProperty('--ion-safe-area-right', `0px`);
        // 실패한 경우에도 한 번 정도는 재시도
        if (retry < 2) {
          if (this.safeAreaRetryTimer) clearTimeout(this.safeAreaRetryTimer);
          this.safeAreaRetryTimer = setTimeout(() => this.applyAndroidSafeArea(retry + 1), 150);
        }
      });
  }

  private async applyAndroidStatusBarStyle() {
    if (Capacitor.getPlatform() !== 'android') return;
    try {
      // await StatusBar.setBackgroundColor({ color: '#000000' });
      await StatusBar.setStyle({ style: Style.Light }); // 흰 아이콘(라이트 스타일)
    } catch (e) {
      // ignore
    }
  }
}
